import store from '../store';

const PAYPAL_BUTTON_CONTAINER_ID = 'paypal-button';
const isProduction = process.env.NODE_ENV === 'production';

window.setupPaypalButton = function(onError = () => {}) {
  const container = document.getElementById(PAYPAL_BUTTON_CONTAINER_ID);

  if (!container) {
    console.error(
      `Cannot setup paypal button as the container (#${PAYPAL_BUTTON_CONTAINER_ID}) cannot be found!`
    );
    return;
  }

  const { color = 'gold' } = container.dataset;

  paypal.Button.render(
    {
      env: isProduction ? 'production' : 'sandbox',

      style: {
        label: 'checkout',
        size: 'responsive',
        shape: 'rect',
        color,
        tagline: false,
      },

      payment: function(data, actions) {
        const { cart } = store.state;
        const items = cart.items.map(({ extra }) => extra);
        const coupon = cart.coupon;

        return actions
          .request({
            url: '/api/checkout/setup',
            method: 'post',
            json: {
              items,
              coupon,
              subscribe_to_mailing_list: cart.subscribeToMailingList,
            },
          })
          .then(function(res) {
            if (res.error || !res.payment_id) {
              return onError(res);
            }

            return res.payment_id;
          })
          .catch(function() {
            // This error is unknown, but we should still report the failure
            onError(null);
          });
      },
      onAuthorize: function(data, actions) {
        return actions
          .request({
            url: '/api/checkout/execute',
            method: 'post',
            json: {
              payment_id: data.paymentID,
              payer_id: data.payerID,
            },
          })
          .then(function(res) {
            const { error, redeem_url } = res;
            if (error || !redeem_url) {
              return onError(res);
            }

            store.commit('cart/clear');
            window.location = redeem_url;
          })
          .catch(function() {
            // This error is unknown, but we should still report the failure
            onError(null);
          });
      },
    },
    `#${PAYPAL_BUTTON_CONTAINER_ID}`
  );
};
